<div class="rebate_wrap ">

    <div class="rebate-tabs flex gap-x-5 mt-4">
        <div *ngFor="let tab of tabs"
            class="tab-item cursor-pointer h-[58px] flex-1 text-center bg-[#007BC014] text-[#000]"
            [class.active]="activeTab === tab.key" (click)="switchTab(tab.key)">
            {{ tab.label | translate }}
        </div>
    </div>

    <div class="my-4 flex justify-between items-center">
        <div class="flex justify-between items-center text-[16px]">
            <span>数据更新时间：{{latestUpdateTime}}</span>
            <div class="text-right ml-10">数据截至上一个工作日，仅供参考，请以线下结算为准。</div>
          </div>
        <div class="flex">
            <span style="font-size: 16px; display: flex; align-items: center; margin-right: 20px;">单位：元</span>
            <nz-select [(ngModel)]="selectedYear" class="w-[150px] bosch-select" (ngModelChange)="onYearChange($event)">
                <nz-option *ngFor="let year of yearList" [nzValue]="year" [nzLabel]="year + '年'"> </nz-option>
            </nz-select>
        </div>
    </div>

    <div class="tab-content mt-4">
        <!-- 已结算返利明细 -->
        <div class="rebate-table" *ngIf="activeTab === 'settled'">
            <nz-table [nzData]="settledList" [nzFrontPagination]="false" #fixedTable  [nzScroll]="{ x: 'max-content' }"
            [nzTotal]="paginationMap['settled'].total"
            [nzPageIndex]="paginationMap['settled'].pageNum"
            [nzPageSize]="paginationMap['settled'].pageSize"
            (nzPageIndexChange)="handleChangeCurrentPage($event,'settled')"
            (nzPageSizeChange)="handleChangeCurrentPage($event,'settled')">
                <thead>
                    <tr>
                        <th nzWidth="100px" nzAlign="center">{{ 'REBATE_SETTLEMENT' | translate }}</th>
                        <!-- <th nzWidth="220px">{{ 'CORRESPONDING_SALES' | translate }}</th> -->
                        <th nzWidth="120px" nzAlign="center">{{ 'SETTLEMENT_START_DATE' | translate }}</th>
                        <th nzWidth="120px" nzAlign="center">{{ 'SETTLEMENT_END_DATE' | translate }}</th>
                        <th nzWidth="150px">{{ 'MAIN_CONTRACT_SETTLEMENT' | translate }}</th>
                        <th nzWidth="160px">{{ 'SUPPLEMENTARY_CONTRACT_SETTLEMENT' | translate }}</th>
                        <th nzWidth="150px">{{ 'MARKET_REBATE' | translate }}</th>
                        <th nzWidth="150px">{{ 'TOTAL_REBATE_AMOUNT' | translate }}</th>
                        <th nzWidth="130px" nzAlign="center">{{ 'REBATE_EXCHANGE_METHOD' | translate }}</th>
                        <th nzWidth="200px" nzAlign="center">{{ 'REASON' | translate }}</th>
                        <th nzWidth="100px" nzAlign="center">{{ 'REBATE_STATUS' | translate }}</th>
                        <th nzWidth="170px" nzAlign="center" nzRight>{{ 'REBATE_ACTION' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of settledList">
                        <td nzAlign="center">{{ item.rebateSettlementNo}}</td>
                        <!-- <td>{{ item.settlementCustomer}}</td> -->
                        <td nzAlign="center">{{ item.settlementPeriodStart | date:'yyyy-MM-dd'}}</td>
                        <td nzAlign="center">{{ item.settlementPeriodEnd | date:'yyyy-MM-dd'}}</td>
                        <td>{{ formatMoney(item.mainContractSettle)}}</td>
                        <td>{{ formatMoney(item.additionalContractSettle)}}</td>
                        <td>{{ formatMoney(item.marketRebateSettle)}}</td>
                        <td>{{ formatMoney(item.rebateTotalAmount)}}</td>
                        <td nzAlign="center">{{ item.rebateExchangeMethod}}</td>
                        <td nzAlign="center">{{ item.comment}}</td>
                        <td nzAlign="center">
                            <div class="flex-center">
                                <custom-tag [content]="item.approvalStatus" [backgroundColor]="getColorByStatus(item.approvalStatus,true,false)"
                                [fontColor]="getColorByStatus(item.approvalStatus,false,false)"
                                [borderColor]="getColorByStatus(item.approvalStatus,false,true)"></custom-tag>
                            </div>

                        </td>
                        <td nzAlign="center" nzRight>
                            <a (click)="onView(item)" class="!text-[#007BC0] mr-2" *ngIf="item.rebateSettlementFile!='' && item.rebateSettlementFile">{{ 'VIEW' | translate }}</a>
                            <a (click)="onReview(item)" class="!text-[#007BC0] mr-2"  *ngIf="item.approvalStatus=='审批中'">
                                {{ 'REVIEW' | translate }}
                            </a>
                            <a  class="!text-[#007BC0]" nz-dropdown
                            [nzDropdownMenu]="menu">{{ 'DOWNLOAD' | translate }}</a>
                               <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu>
                                    <li nz-menu-item  class="!text-[#007BC0]" (click)="onDownload(item.rebateSettlementId)">excel格式 ></li>
                                    <li nz-menu-item  class="!text-[#007BC0]" *ngIf="item.rebateSettlementFile!='' && item.rebateSettlementFile" (click)="onDownloadPDF(item.rebateSettlementId)">pdf格式 ></li>
                                </ul>
                            </nz-dropdown-menu>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
        </div>

        <!-- 已发放返利明细 -->
        <div class="rebate-table" *ngIf="activeTab === 'released'">
            <nz-table [nzData]="releasedList" [nzFrontPagination]="false"
            [nzTotal]="paginationMap['released'].total"
            [nzPageIndex]="paginationMap['released'].pageNum"
            [nzPageSize]="paginationMap['released'].pageSize"
            (nzPageIndexChange)="handleChangeCurrentPage($event,'released')"
            (nzPageSizeChange)="handleChangeCurrentPage($event,'released')">
                <thead>
                    <tr>
                        <th nzWidth="25%" nzAlign="center">{{ 'ACTUAL_PAYMENT_DATE' | translate }}</th>
                        <!-- <th>{{ 'SETTLEMENT_START_DATE' | translate }}</th>
                        <th>{{ 'SETTLEMENT_END_DATE' | translate }}</th>
                        <th>{{ 'CONTRACT_NO' | translate }}</th>
                        <th>{{ 'PURCHASE_TARGET' | translate }}</th>
                        <th>{{ 'NET_PURCHASE_AMOUNT' | translate }}</th>
                        <th>{{ 'COMPLETION_RATE' | translate }}</th>
                        <th>{{ 'EXPECTED_REBATE_AMOUNT' | translate }}</th>
                        <th>{{ 'SETTLED_REBATE_AMOUNT' | translate }}</th> -->
                        <th nzWidth="25%" nzAlign="center">{{ 'DISTRIBUTION_NO' | translate }}</th>
                        <th nzWidth="25%" nzAlign="center">{{ 'REBATE_SETTLEMENT_NO' | translate }}</th>
                        <th nzWidth="25%" class="pr-4">{{ 'PAID_REBATE_AMOUNT' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of releasedList">
                        <td nzAlign="center">{{ item.dateFf | date:'yyyy-MM-dd'}}</td>
                        <!-- <td>{{ item.settlementPeriodStart | date:'yyyy-MM-dd'}}</td>
                        <td>{{ item.settlementPeriodEnd | date:'yyyy-MM-dd'}}</td>
                        <td>{{ item.ssqContractNo}}</td>
                        <td>{{ formatMoney(item.purchaseTarget)}}</td>
                        <td>{{ formatMoney(item.purchaseAmount)}}</td>
                        <td>{{ (item.completionRate * 100).toFixed(0)}}%</td>
                        <td>{{ formatMoney(item.estimatedRebateAmount)}}</td>
                        <td>{{ formatMoney(item.settledRebateAmount)}}</td> -->
                        <td nzAlign="center">{{ item.name}}</td>
                        <td nzAlign="center">{{ item.rebateCalName}}</td>
                        <td>{{ formatMoney(item.totalAmt)}}</td>
                    </tr>
                </tbody>
                <tfoot nzSummary *ngIf="isReleasedRebateDisplay">
                    <tr style="background-color: #007BC014;">
                        <td class="text-center">{{ 'TOTAL' | translate}}</td>
                        <td></td>
                        <td></td>
                        <!-- <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <span nz-typography>{{ formatMoney(totalEstimatedRebateAmount) }}</span>
                        </td>
                        <td>
                            <span nz-typography>{{ formatMoney(totalSettledRebateAmount) }}</span>
                        </td> -->
                        <td class="text-right">
                            <span nz-typography>{{ formatMoney(totalTotalAmount) }}</span>
                        </td>
                    </tr>
                </tfoot>
            </nz-table>
        </div>


        <div class="rebate-table" *ngIf="activeTab === 'used'">
            <!-- 已使用返利明细 -->
            <nz-table [nzData]="usedList" [nzFrontPagination]="false"
            [nzTotal]="paginationMap['used'].total"
            [nzPageIndex]="paginationMap['used'].pageNum"
            [nzPageSize]="paginationMap['used'].pageSize"
            (nzPageIndexChange)="handleChangeCurrentPage($event,'used')"
            (nzPageSizeChange)="handleChangeCurrentPage($event,'used')">
                <thead>
                    <tr>
                        <th nzAlign="center">{{ 'REBATE_ORDER_NO' | translate }}</th>
                        <th nzAlign="center">{{ 'USAGE_TYPE' | translate }}</th>
                        <th nzAlign="center">{{ 'ORDER_CREATE_TIME' | translate }}</th>
                        <th nzAlign="center">{{ 'REBATE_USAGE_TIME' | translate }}</th>
                        <th>{{ 'REBATE_USAGE_AMOUNT' | translate }}</th>
                        <th>{{ 'REBATE_USAGE_AMOUNT_WITH_TAX' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of usedList">
                        <td nzAlign="center">{{ item.orderNo}}</td>
                        <td nzAlign="center">{{ item.type}}</td>
                        <td nzAlign="center">{{ item.orderCrDate | date:'yyyy-MM-dd'}}</td>
                        <td nzAlign="center">{{ item.rebateUseDate | date:'yyyy-MM-dd'}}</td>
                        <td>{{ formatMoney(item.actualAmount)}}</td>
                        <td>{{ multiplyFormatted(item.actualAmount)}}</td>
                    </tr>
                </tbody>
                <tfoot nzSummary *ngIf="isUsedRebateDisplay">
                    <tr style="background-color: #007BC014;">
                        <td class="text-center">{{ 'TOTAL' | translate}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                            <span nz-typography>{{ formatMoney(totalRebateUsedAmount) }}</span>
                        </td>
                        <td class="text-right">
                            <span nz-typography>{{ multiplyFormatted(totalRebateUsedAmount) }}</span>
                        </td>
                    </tr>
                </tfoot>
            </nz-table>
        </div>


    </div>

    <nz-modal [(nzVisible)]="modalVisible" [nzTitle]="'REVIEW' | translate" [nzFooter]="modalFooter" [nzWidth]="600"
        [nzContent]="modalContent" (nzOnCancel)="modalVisible = false">
        <ng-template #modalContent>
            <nz-form-item class="my-10">
                <nz-form-label [nzSpan]="3">{{'REASON' | translate}}</nz-form-label>
                <nz-form-control [nzSpan]="21">
                    <textarea nz-input [nzRows]="8" [(ngModel)]="comment" maxlength="20"
                        [placeholder]="'PLEASE_INPUT' | translate" class="w-full bosch_textarea"></textarea>
                </nz-form-control>
            </nz-form-item>
        </ng-template>


        <!-- 自定义按钮 -->
        <ng-template #modalFooter>
            <button nz-button nzType="default" appDebounceClick (debounceClick)="handleOk(0)">
                {{ 'REJECT' | translate }}
            </button>
            <button nz-button nzType="primary" appDebounceClick  (debounceClick)="handleOk(1)">
                {{ 'APPROVE' | translate }}
            </button>
        </ng-template>
    </nz-modal>


</div>
